<mat-toolbar color="primary" class="dark-nav">
  <div class="navbar-brand">
    <!-- Mobile Menu Button -->
    @if (loggedIn()) {
      <button
        mat-icon-button
        class="mobile-menu-button mobile-only"
        (click)="toggleMobileMenu()"
        aria-label="Toggle menu"
        >
        <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
      </button>
    }

    <a href="#" class="logo-link">
      <img
        class="navbar-logo"
        src="./assets/images/amigo_logo.webp"
        alt="Pendelportalen"
        />
        <span class="app-name desktop-only">Pendelportalen</span>
        <span class="app-name mobile-only">{{ currentPageName }}</span>
      </a>
    </div>

    <!-- Desktop Tabs Menu -->
    @if (loggedIn()) {
      <div class="tabs-container desktop-only">
        <nav class="tabs">
          @for (menuItem of menuItems; track menuItem) {
            @if (shouldShow(menuItem) && menuItem.children) {
              <button
                class="tab-button"
                [matMenuTriggerFor]="dropMenu"
                [class.active]="isChildRouteActive(menuItem)"
                >
                <span class="tab-text">{{ menuItem.displayName }}</span>
                <mat-icon class="dropdown-arrow-icon">arrow_drop_down</mat-icon>
              </button>
              <mat-menu #dropMenu="matMenu">
                @for (child of menuItem.children; track child) {
                  @if (shouldShow(child)) {
                    <a
                      mat-menu-item
                      [routerLink]="child.path"
                      routerLinkActive="active-mat-menu-item"
                      >
                      {{ child.displayName }}
                    </a>
                  }
                }
              </mat-menu>
            }
            @if (shouldShow(menuItem) && !menuItem.redirect && !menuItem.children) {
              <a
                class="tab-button"
                [routerLink]="menuItem.path"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: menuItem.path === '' }"
                >
                <span class="tab-text">{{ menuItem.displayName }}</span>
              </a>
            }
            @if (shouldShow(menuItem) && menuItem.redirect) {
              <a
                class="tab-button"
                [href]="menuItem.path"
                target="_blank"
                rel="noopener noreferrer"
                >
                <span class="tab-text">{{ menuItem.displayName }}</span>
                <mat-icon class="external-icon">open_in_new</mat-icon>
              </a>
            }
          }
        </nav>
      </div>
    }

    @if (loggedIn()) {
      <div class="right-side-menu-item">
        <div class="user-menu-item">
          <mat-icon class="menu-icon" aria-hidden="false" aria-label="User">
            person
          </mat-icon>
          <span class="user-name">{{ user() }}</span>
        </div>
        <button
          mat-icon-button
          class="transparent-button"
          [matTooltip]="isDarkMode ? 'Ljust läge' : 'Mörkt läge'"
          (click)="themeService.toggle()"
          aria-label="Toggle dark mode"
          >
          <mat-icon class="menu-icon">{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
        <button
          mat-icon-button
          aria-label="Sign out"
          class="transparent-button"
          (click)="logout()"
          >
          <mat-icon class="menu-icon">exit_to_app</mat-icon>
        </button>
      </div>
    }
  </mat-toolbar>

  <!-- Mobile Menu Overlay -->
  @if (loggedIn() && isMobileMenuOpen) {
    <div class="mobile-menu-overlay" (click)="closeMobileMenu()">
      <nav class="mobile-menu" (click)="$event.stopPropagation()">
        <div class="mobile-menu-header">
          <h2>Pendelportalen</h2>
          <button mat-icon-button (click)="closeMobileMenu()" aria-label="Close menu">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <ul class="mobile-menu-items">
          @for (menuItem of menuItems; track menuItem) {
            @if (shouldShow(menuItem)) {
              <li [class.mobile-menu-group]="!!menuItem.children">
                @if (menuItem.children) {
                  <span class="mobile-menu-section-label">{{ menuItem.displayName }}</span>
                  <ul class="mobile-submenu">
                    @for (child of menuItem.children; track child) {
                      <li>
                        @if (shouldShow(child)) {
                          <a
                            class="mobile-menu-item mobile-submenu-item"
                            [routerLink]="child.path"
                            routerLinkActive="active"
                            (click)="closeMobileMenu()"
                            >
                            <span class="mobile-menu-item-text">{{ child.displayName }}</span>
                          </a>
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  @if (!menuItem.redirect) {
                    <a
                      class="mobile-menu-item"
                      [routerLink]="menuItem.path"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: menuItem.path === '' }"
                      (click)="closeMobileMenu()"
                      >
                      <span class="mobile-menu-item-text">{{ menuItem.displayName }}</span>
                    </a>
                  }
                  @if (menuItem.redirect) {
                    <a
                      class="mobile-menu-item"
                      [href]="menuItem.path"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="closeMobileMenu()"
                      >
                      <span class="mobile-menu-item-text">{{ menuItem.displayName }}</span>
                      <mat-icon class="mobile-external-icon">open_in_new</mat-icon>
                    </a>
                  }
                }
              </li>
            }
          }
        </ul>
      </nav>
    </div>
  }
